/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_ScoreInputs */

const th_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึกคะแนน`)
};

const en_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter score`)
};

const ja_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スコアを入力`)
};

const zh_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录入比分`)
};

const es_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introducir resultado`)
};

const pt_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançar placar`)
};

const id_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan skor`)
};

const fr_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir le score`)
};

const tl_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilagay ang iskor`)
};

const vi_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập tỉ số`)
};

const ko_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`점수 입력`)
};

const de_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis eintragen`)
};

const ru_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ввести счёт`)
};

const tr_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor gir`)
};

const it_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il punteggio`)
};

const pl_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisz wynik`)
};

const uk_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ввести рахунок`)
};

const hi_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्कोर दर्ज करें`)
};

const ar_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدخال النتيجة`)
};

const ms_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan mata`)
};

const bn_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্কোর দিন`)
};

const zh_tw2_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入比分`)
};

const zh_hk2_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入比分`)
};

const ur_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکور درج کریں`)
};

const fa_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وارد کردن نتیجه`)
};

const sw_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka matokeo`)
};

const nl_enter_score = /** @type {(inputs: Enter_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand invoeren`)
};

/**
* | output |
* | --- |
* | "Enter score" |
*
* @param {Enter_ScoreInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const enter_score = /** @type {((inputs?: Enter_ScoreInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_ScoreInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_enter_score(inputs)
	if (locale === "ja") return ja_enter_score(inputs)
	if (locale === "zh") return zh_enter_score(inputs)
	if (locale === "es") return es_enter_score(inputs)
	if (locale === "pt") return pt_enter_score(inputs)
	if (locale === "id") return id_enter_score(inputs)
	if (locale === "fr") return fr_enter_score(inputs)
	if (locale === "tl") return tl_enter_score(inputs)
	if (locale === "vi") return vi_enter_score(inputs)
	if (locale === "ko") return ko_enter_score(inputs)
	if (locale === "de") return de_enter_score(inputs)
	if (locale === "ru") return ru_enter_score(inputs)
	if (locale === "tr") return tr_enter_score(inputs)
	if (locale === "it") return it_enter_score(inputs)
	if (locale === "pl") return pl_enter_score(inputs)
	if (locale === "uk") return uk_enter_score(inputs)
	if (locale === "hi") return hi_enter_score(inputs)
	if (locale === "ar") return ar_enter_score(inputs)
	if (locale === "ms") return ms_enter_score(inputs)
	if (locale === "bn") return bn_enter_score(inputs)
	if (locale === "zh-TW") return zh_tw2_enter_score(inputs)
	if (locale === "zh-HK") return zh_hk2_enter_score(inputs)
	if (locale === "ur") return ur_enter_score(inputs)
	if (locale === "fa") return fa_enter_score(inputs)
	if (locale === "sw") return sw_enter_score(inputs)
	if (locale === "nl") return nl_enter_score(inputs)
	return en_enter_score(inputs)
});